// extracted by mini-css-extract-plugin
export default {"zoomModal":"v3-z","image":"w3-z","button":"x3-z","isOverlayShown":"y3-z"};